import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Input, Label, Row } from 'reactstrap';
import { btnEdit } from '../../../constants/Style';
import { updateProject } from '../../../redux/actions/projects';
import {
  cancelUnsavedChanges,
  unsavedChanges,
} from '../../../redux/actions/save';
import store from '../../../redux/store';

/**
 * Project Name Panel
 *
 * Panel for displaying and editing the project name
 *
 * @param data: parameter for the specific project in the project details page
 * @param updateProject: redux action to update a project
 * @param profile: fetches profile of the current user in the system
 */
const ProjectNamePanel = ({
  data,
  updateProject,
  profile,
  save,
  unsavedChanges,
}) => {
  const [editMode, setEditMode] = useState(false);
  const changeMode = () => {
    if (editMode) {
      setFormData({ ...formData, name: data?.name });
    }
    setEditMode(!editMode);
  };
  const [formData, setFormData] = useState({
    name: '',
  });

  useEffect(() => {
    setFormData({
      ...formData,
      name: data?.name,
    });
  }, [data]);
  const [fieldId, setFieldId] = useState(null);

  //Event handling for inputs
  const onChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
    if (!fieldId) {
      const id = unsavedChanges();
      setFieldId(id);
    }
  };

  const { dispatch } = store;
  const onSubmit = async () => {
    updateProject(data._id, formData);
    dispatch(cancelUnsavedChanges(fieldId));
    setFieldId(null);
  };

  useEffect(() => {
    if (save && editMode) {
      updateProject(data._id, formData);
      changeMode();
      setFieldId(null);
    }
  }, [save]);

  return (
    <div style={{ marginLeft: '-15px' }}>
      {editMode ? (
        <div>
          <Row>
            <Col lg='6'>
              <div className='bold'>Name</div>
              <Input
                type='text'
                name='name'
                className='project-info-edit'
                onChange={onChange}
                value={formData.name}
                style={{ width: '500px' }}
              />
              <br />
              <div style={{ marginLeft: '320px' }}>
                <td className='no-border'>
                  <Button
                    className='btn-add'
                    onClick={() => {
                      onSubmit();
                      changeMode();
                    }}
                  >
                    Save
                  </Button>
                </td>
                <td className='no-border'>
                  <Button
                    className='btn-danger'
                    onClick={() => {
                      changeMode();
                      dispatch(cancelUnsavedChanges(fieldId));
                      setFieldId(null);
                    }}
                  >
                    Cancel
                  </Button>
                </td>
              </div>
            </Col>
          </Row>
        </div>
      ) : (
        <div className='project-details-label' style={{ width: '100%' }}>
          <div style={{ width: '88px' }}>
            {data?.baseline === undefined ? (
              data?.participants
                ?.find(
                  (member) => parseInt(member.user_id) === parseInt(profile?.id)
                )
                ?.role.includes('owner') ||
              data?.participants
                ?.find(
                  (member) => parseInt(member.user_id) === parseInt(profile?.id)
                )
                ?.role.includes('editor') ? (
                <Button
                  className='float-right'
                  onClick={() => changeMode()}
                  style={btnEdit}
                >
                  <i className='fa fa-edit' />
                </Button>
              ) : null
            ) : null}
            <div className='bold'>Name</div>
          </div>
          <Label>
            <h4 className='bold'>
              {data?.baseline === undefined ? (
                <>{data?.name}</>
              ) : (
                <>{`Baseline ${data?._id}: ${data?.name}`}</>
              )}
            </h4>
          </Label>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  profile: state.profile.profile,
});

export default connect(mapStateToProps, { updateProject, unsavedChanges })(
  ProjectNamePanel
);
